import { NgModule } from '@angular/core';
import { UIRouterModule } from "@uirouter/angular";
import { OpenprojectWorkPackagesModule } from "core-app/features/work-packages/openproject-work-packages.module";
import { OPENPROJECT_METEOR_CORE_ROUTES } from "./routes";
import { OpSharedModule } from "core-app/shared/shared.module";
import { WorkPackageViewPageIframeComponent } from "./components/wp-view-page-iframe.component";
import { WorkPackageListViewIframeComponent } from "./components/wp-list-view-iframe.component";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiKeyInterceptor } from './http/api-key-interceptor';
import { apply as applyWorkPackagesQueryViewServicePatch } from './patches/wp-query-view.service.patch'

applyWorkPackagesQueryViewServicePatch();

@NgModule({
  declarations: [
    WorkPackageViewPageIframeComponent,
    WorkPackageListViewIframeComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ApiKeyInterceptor, multi: true },
  ],
  imports: [
    OpSharedModule,
    OpenprojectWorkPackagesModule,

    UIRouterModule.forChild({ states: OPENPROJECT_METEOR_CORE_ROUTES }),
  ],
})
export class PluginModule {
}
